// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-FormBuilder-BuildEditorInstructions-module__BuildEditorInstructions";
export { _1 as "BuildEditorInstructions" }
